import { useId } from "react";

import { inputClass, NotSaved, Status } from "../settings/fields";

/** A person's time zone, chosen by its IANA name (ADRs 0172 and 0200). */
export function TimeZoneSelect({
  person,
  zones,
  shown,
  status,
  error,
  onChoose,
}: {
  person: string;
  zones: readonly string[];
  /** What's being saved, while it saves; then what's saved. */
  shown: string;
  status: string | undefined;
  error: string | undefined;
  onChoose: (zone: string) => void;
}) {
  const id = useId();
  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={id} className="sr-only">
        {`Time zone for ${person}`}
      </label>
      <select
        id={id}
        className={`${inputClass} w-full max-w-72 cursor-pointer`}
        value={shown}
        aria-invalid={Boolean(error)}
        aria-describedby={error ? `${id}-problem` : undefined}
        onChange={(event) => {
          onChoose(event.target.value);
        }}
      >
        {zones.map((zone) => (
          <option key={zone} value={zone}>
            {zone}
          </option>
        ))}
      </select>
      <Status status={status} />
      <NotSaved id={`${id}-problem`} reason={error} />
    </div>
  );
}
